import { CSSProgressiveBody03 } from "@caisy/league";
import styled from "styled-components";

export const SCreateProjectCardDescription = styled.div`
  ${CSSProgressiveBody03};
  color: var(--text-04);
  margin: 0 auto;
  text-align: center;
`;
